module.exports = __webpack_public_path__ + "img/spyBoat.7313a5f3.png";